import * as React from 'react';
import { IBaseProps } from '../../types/props';
import { logGAPageView } from '../../utils/google-analytics';

import * as styles from './gs360.css';

import { NavigationHero } from './redirect-components/navigation-hero';
import { NavigationBar } from './redirect-components/navigation';
import { UpdateCard } from './redirect-components/update-card';
import { Category } from './redirect-components/category';
import { Footer } from './redirect-components/footer';

interface IGS360Props extends IBaseProps {
  history: {
    push: (url: string) => void;
  };
}

export class GS360 extends React.PureComponent<IGS360Props, any> {
  componentDidMount() {
    logGAPageView();
  }

  backgroundImage = require(`../../assets/images/discover-header.jpg`);
  marqueeLogoImage = require(`../../assets/images/marquee.png`);
  gs360LogoImage = require(`../../assets/images/gs360.png`);

  render() {
    return (
      <div className={styles.gs360}>
        <NavigationHero
          navigation={
            <NavigationBar leftImage={this.marqueeLogoImage} rightImage={this.gs360LogoImage} />
          }
          backgroundImage={this.backgroundImage}
        >
          <UpdateCard />
        </NavigationHero>
        <Category />
        <Footer />
      </div>
    );
  }
}
